import {
  BedDouble,
  Car,
  CarTaxiFront,
  Coffee,
  Fuel,
  CircleParking,
  Printer,
  ShoppingBag,
  Store,
  TrainFront,
  Utensils,
  type LucideIcon,
} from 'lucide-react';
import type { SiteCategory } from './api';

const ICON: Record<SiteCategory, LucideIcon> = {
  restaurant: Utensils,
  hotel: BedDouble,
  bar: Coffee,
  copy_shop: Printer,
  ncc: Car,
  taxi: CarTaxiFront,
  car_rental: Car,
  transport: TrainFront,
  fuel: Fuel,
  parking: CircleParking,
  shop: ShoppingBag,
  other: Store,
};

/** One glyph per site type, the same as the list's map (board 4); a shop front without one. */
export function CategoryIcon({ category }: { readonly category: SiteCategory | null }) {
  const Icon = category ? ICON[category] : Store;
  return <Icon aria-hidden="true" className="size-4" />;
}
